module.exports = __webpack_public_path__ + "static/hightower-81bcec7604e64f10426a23316ff6d6a7.png";